export default {
  tabs: [],
  activeTab: {},
  sorts: [],
  hasLoadMore: false,
  searchType: null,
  searchTerm: null,
  isFirstLoad: true,
  updateHistory: false,
  filters: {},
  appliedFilter: false,
  query: {},
};
